import Backdrop, { BackdropProps } from 'components/backdrop';
import { FC } from 'react';
import styled from 'styled-components';
import { breakpoints } from 'styles/theme';

export interface ContentBlockProps extends BackdropProps {
  flip?: boolean;
}

const Grid = styled.div`
  display: grid;
  gap: var(--padding);
  align-items: center;

  @media screen and (min-width: ${breakpoints.medium}) {
    grid-template-areas: 'left right';
    grid-template-columns: repeat(2, 1fr);

    > * {
      &:nth-child(1) {
        grid-area: left;
      }

      &:nth-child(2) {
        grid-area: right;
      }
    }

    &[data-flipped='true'] {
      > * {
        &:nth-child(1) {
          grid-area: right;
        }

        &:nth-child(2) {
          grid-area: left;
        }
      }
    }
  }
`;

const ContentBlock: FC<ContentBlockProps> = ({
  backgroundColor,
  flourishBottomRight,
  flourishTopLeft,
  flip,
  children,
}) => {
  return (
    <Backdrop
      backgroundColor={backgroundColor}
      flourishTopLeft={flourishTopLeft}
      flourishBottomRight={flourishBottomRight}
    >
      <Grid data-flipped={flip}>{children}</Grid>
    </Backdrop>
  );
};

export default ContentBlock;
